import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import TeamPage from "./pages/TeamPage";
import CalculatorsPage from "./pages/CalculatorsPage";
import NRIPage from "./pages/NRIPage";
import ContactPage from "./pages/ContactPage";
import WealthBuilderPage from "./pages/WealthBuilderPage";
import GoalPlannerPage from "./pages/GoalPlannerPage";
import InsurancePage from "./pages/InsurancePage";
import RetirementPage from "./pages/RetirementPage";
import TaxOptimizationPage from "./pages/TaxOptimizationPage";
import MutualFundsPage from "./pages/MutualFundsPage";
import NRIConnectPage from "./pages/NRIConnectPage";
import ResearchHubPage from "./pages/research/ResearchHubPage";
import SchemePerformancePage from "./pages/research/SchemePerformancePage";
import RiskMetricsPage from "./pages/research/RiskMetricsPage";
import SchemeTrendsPage from "./pages/research/SchemeTrendsPage";
import SchemeComparisonPage from "./pages/research/SchemeComparisonPage";
import LiveSIPAnalysisPage from "./pages/research/LiveSIPAnalysisPage";
import LiveSWPAnalysisPage from "./pages/research/LiveSWPAnalysisPage";
import NAVTrackerPage from "./pages/research/NAVTrackerPage";
import DecliningNAVPage from "./pages/research/DecliningNAVPage";
import CalculatorsHubPage from "./pages/CalculatorsHubPage";
import GoalPlanningPage from "./pages/calculators/GoalPlanningPage";
import FinancialPlanningPage from "./pages/calculators/FinancialPlanningPage";
import CrorepatiCalculatorPage from "./pages/calculators/CrorepatiCalculatorPage";
import InteractiveCrorepatiPage from "./pages/calculators/InteractiveCrorepatiPage";
import SIPEMIPage from "./pages/calculators/SIPEMIPage";
import InteractiveSIPvsEMI from "./pages/calculators/InteractiveSIPvsEMI";
import SIPCalculatorPage from "./pages/calculators/SIPCalculatorPage";
import EmergencyPlanningPage from "./pages/calculators/EmergencyPlanningPage";
import InteractiveGoalPlanner from "./pages/calculators/InteractiveGoalPlanner";
import InteractiveMarriagePlanner from "./pages/calculators/InteractiveMarriagePlanner";
import InteractiveEducationPlanner from "./pages/calculators/InteractiveEducationPlanner";
import InteractiveHousePlanner from "./pages/calculators/InteractiveHousePlanner";
import InteractiveEmergencyFund from "./pages/calculators/InteractiveEmergencyFund";
import PortfolioForecastingPage from "./pages/calculators/PortfolioForecastingPage";
import PortfolioUploadPage from "./pages/PortfolioUploadPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/calculators" element={<CalculatorsHubPage />} />
          <Route path="/nri" element={<NRIConnectPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/wealth-builder" element={<WealthBuilderPage />} />
          <Route path="/goal-planner" element={<GoalPlannerPage />} />
          <Route path="/insurance" element={<InsurancePage />} />
          <Route path="/retirement" element={<RetirementPage />} />
          <Route path="/tax-optimization" element={<TaxOptimizationPage />} />
          <Route path="/mutual-funds" element={<MutualFundsPage />} />
          <Route path="/research" element={<ResearchHubPage />} />
          <Route path="/scheme-performance" element={<SchemePerformancePage />} />
          <Route path="/risk-metrics" element={<RiskMetricsPage />} />
          <Route path="/scheme-trends" element={<SchemeTrendsPage />} />
          <Route path="/scheme-comparison" element={<SchemeComparisonPage />} />
          <Route path="/live-sip-analysis" element={<LiveSIPAnalysisPage />} />
          <Route path="/live-swp-analysis" element={<LiveSWPAnalysisPage />} />
          <Route path="/nav-tracker" element={<NAVTrackerPage />} />
          <Route path="/declining-nav" element={<DecliningNAVPage />} />
          <Route path="/calculators/goal-planning" element={<GoalPlanningPage />} />
          <Route path="/calculators/financial-planning" element={<FinancialPlanningPage />} />
          <Route path="/calculators/crorepati" element={<InteractiveCrorepatiPage />} />
          <Route path="/calculators/sip-emi" element={<InteractiveSIPvsEMI />} />
          <Route path="/calculators/sip" element={<SIPCalculatorPage />} />
          <Route path="/calculators/emergency" element={<InteractiveEmergencyFund />} />
          <Route path="/calculators/goal-planner" element={<InteractiveGoalPlanner />} />
          <Route path="/calculators/marriage" element={<InteractiveMarriagePlanner />} />
          <Route path="/calculators/education" element={<InteractiveEducationPlanner />} />
          <Route path="/calculators/house" element={<InteractiveHousePlanner />} />
          <Route path="/calculators/portfolio-forecast" element={<PortfolioForecastingPage />} />
          <Route path="/portfolio-upload" element={<PortfolioUploadPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
